module.exports = __webpack_public_path__ + "static/img/4be7beef.c10.fcaa339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/4be7beef.c10.jpg
// module id = uPEw
// module chunks = 2